import { Button, CircularProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Field, Form, Formik } from "formik";
import { JSEncrypt } from "jsencrypt";
import React, { useState } from "react";
import useApi from "../../../hooks/api";
import useAuth from "../../../hooks/auth";
import Alert from "../../ui/alert";
import { Textfield } from "../../ui/form_fields";

const LoginButton = withStyles(() => {
  return {
    root: {
      fontFamily: "Inter, sans-serif",
      borderRadius: "100px",
      color: "#fff !important",
      backgroundColor: "#4062B6 !important",
      "&:hover": {
        backgroundColor: "#27499D !important",
        cursor: "pointer !important",
      },
    },
  };
})(Button);

const encryptCredentials = (credentials) => {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(window.DEVISE_PUBLIC_KEY);
  return encrypt.encrypt(JSON.stringify(credentials));
};

const initialValues = { email: "", password: "" };

export default () => {
  const { setAuth } = useAuth();
  const { post } = useApi();
  const [error, setError] = useState();

  const submitLogin = async ({ email, password }, { setSubmitting }) => {
    setError(null);
    setSubmitting(true);

    const payload = encryptCredentials({ email, password });

    try {
      const response = await post("/auth/sign_in", { payload });

      setAuth(response);
      window.location.href = "/painel";
    } catch ({ requestErrors }) {
      setError(requestErrors.join(" "));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik initialValues={initialValues} onSubmit={submitLogin}>
      {(formikProps) => (
        <Form>
          {error && (
            <div className="mb-15">
              <Alert title="ATENÇÃO!" message={error} severity="error" />
            </div>
          )}

          <Field
            isRequired={true}
            name="email"
            type="email"
            label="Email"
            inputProps={{ className: "login-form-sep mb-15 m-bg-white" }}
            component={Textfield}
          />

          <Field
            isRequired={true}
            name="password"
            type="password"
            label="Senha"
            inputProps={{ className: "login-form-sep mb-30 m-bg-white" }}
            component={Textfield}
          />

          <footer className="login-footer">
            <LoginButton
              type="submit"
              fullWidth
              value="Login"
              size="large"
              variant="outlined"
              disabled={formikProps.isSubmitting || !formikProps.dirty}
            >
              {formikProps.isSubmitting ? (
                <CircularProgress
                  size={24}
                  style={{ marginBottom: "0px", color: "white" }}
                />
              ) : (
                <span>ACESSAR</span>
              )}
            </LoginButton>
          </footer>
        </Form>
      )}
    </Formik>
  );
};
